<template>
  <div class="combined-wrapper" :class="pollPositionClass">
    <!-- Combined Poll + QR Code Unit -->
    <div class="poll-qrcode-unit">
      <!-- QR Code Section -->
      <div v-if="hasValidQRCode" class="qrcode-section" :class="[pollPositionClass, { 'no-images': !hasOptionsWithImages }]">
        <div class="qrcode-container">
          <img
            :src="item.enquete_qr_code.url"
            :alt="qrCodeAltText"
            class="qrcode-image"
            @error="onQRCodeError"
          />
        </div>
        <div class="participe-label">
          <span>Participe!</span>
        </div>
      </div>

      <!-- Standard Poll Component -->
      <div class="poll-section">
        <CardTarjaEnqueteFechamentoSportv
          :item="item"
          :posicaoEnquete="posicaoEnquete"
          :isFullScreen="isFullScreen"
          :hideTitle="hideTitle"
          :hideOptionTitle="hideOptionTitle"
          />
      </div>
    </div>
  </div>
</template>

<script>
import CardTarjaEnqueteFechamentoSportv from './CardTarjaEnqueteFechamentoSportv.vue';

export default {
  name: 'CardTarjaEnqueteFechamentoSportvWithQRCode',
  components: {
    CardTarjaEnqueteFechamentoSportv,
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    posicaoEnquete: {
      type: String,
      default: 'esquerda'
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideOptionTitle: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    hasValidQRCode() {
      return this.item?.enquete_qr_code?.url && this.item.enquete_qr_code.url.trim() !== '';
    },
    hasOptionsWithImages() {
      return this.item?.enquete_opcoes?.some(opcao => opcao.url_imagem) || false;
    },
    qrCodeAltText() {
      return `QR Code - ${this.item?.dsc_titulo_enquete || 'Participe da Enquete'}`;
    },
    pollPositionClass() {
      const positionMap = {
        'esquerda': 'poll-left',
        'direita': 'poll-right',
        'centro': 'poll-center'
      };
      return positionMap[this.posicaoEnquete] || 'poll-left';
    }
  },
  methods: {
    onQRCodeError(event) {
      console.error('Error loading QR Code image:', event);
      this.$emit('qrcode-error', {
        url: this.item?.enquete_qr_code?.url,
        enqueteId: this.item?.id
      });
    }
  }
}
</script>

<style scoped lang="scss">
@font-face {
  font-family: "Mono45Headline";
  font-weight: 700;
  src: url("@/assets/fonts/FechamentoSportv/Mono45 Headline Bold.ttf") format("truetype");
}

$qrcode-gap: -8px;
$qrcode-width: 166px; // QR image (150px) + container padding (16px)

.combined-wrapper {
  --participe-label-background-gradient: linear-gradient(to top, rgb(255, 255, 255), rgb(255, 255, 255));
  --participe-label-text: #373f19;

  width: 100%;
  height: 100vh;
  display: flex;
  align-items: flex-end;
  position: relative;

  &.poll-left {
    justify-content: flex-start;
    padding-left: calc(40px + #{$qrcode-width} + #{$qrcode-gap});
  }

  &.poll-center {
    justify-content: center;

    .poll-qrcode-unit {
      margin-left: $qrcode-width;
    }
  }

  &.poll-right {
    justify-content: flex-end;
    padding-right: calc(40px + #{$qrcode-width} + #{$qrcode-gap});
  }
}

.poll-qrcode-unit {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  position: relative;
}

.poll-section {
  display: flex;
  align-items: flex-end;

  ::v-deep .fechamento-sportv-container {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

.qrcode-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-bottom: 85px;
  position: absolute;
  bottom: 0;
  right: calc(100% + #{$qrcode-gap});

  &.poll-right {
    right: auto;
    left: calc(100% + #{$qrcode-gap});
  }

  &.no-images {
    right: calc(100% + #{$qrcode-gap});

    &.poll-right {
      right: auto;
      left: calc(100% + #{$qrcode-gap});
    }
  }
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}

.qrcode-image {
  width: 150px;
  height: 150px;
  object-fit: contain;
}

.participe-label {
  background: var(--participe-label-background-gradient);
  padding: 6px 20px;
  margin-top: -13px;

  span {
    display: block;
    font-family: 'Mono45Headline', sans-serif;
    font-weight: 700;
    font-size: 25px;
    color: var(--participe-label-text);
  }
}
</style>
